/* eslint-disable react/jsx-props-no-spreading */
import React, { FC } from 'react';
import './styles.scss';

interface CheckboxProps {
  name: string;
  label?: string;
  wrapperClass?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
  checked?: boolean;
  error?: string;
  disabled?: boolean;
  value?: string;
  theme?: 'primary' | 'secondary';
  themFont?: boolean;
}

export const Checkbox: FC<CheckboxProps> = ({
  name,
  label,
  wrapperClass,
  onChange,
  onClick,
  checked,
  error,
  disabled,
  value,
  theme = 'primary',
  themFont,
}) => {
  const finalTheme = {
    primary: 'color-primary',
    secondary: 'color-secondary',
  }[theme];

  return (
    <div className={`mb-3 d-flex ${wrapperClass}`}>
      <label className="checkbox style-d" htmlFor={name}>
        <input
          type="checkbox"
          name={name}
          id={name}
          checked={checked}
          onChange={onChange}
          onClick={onClick}
          disabled={disabled}
          value={value}
        />
        <div className={`checkbox__checkmark ${finalTheme}`} />
      </label>
      {label && (
        <div className={themFont ? 'd-flex ml-2' : 'd-flex ml-2'}>
          <label
            htmlFor={name}
            className={themFont ? 'input-checkbox-label-filter m-0' : 'input-checkbox-label m-0'}
          >
            {label}
          </label>
          {error && (
            <span role="alert" className="alert-error">
              {error}
            </span>
          )}
        </div>
      )}
    </div>
  );
};
